import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const projects = [{
  id: 1,
  title: "Marriott International",
  tech: "SPEC: VM INFRASTRUCTURE, VIRTUALIZATION",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/it_masters_marriott_deployment.png",
  link: "/HospitalityPage"
}, {
  id: 2,
  title: "Sheraton Hotels",
  tech: "SPEC: NEXT-GEN NETWORKING, CLOUD BACKUP",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/it_masters_sheraton_infrastructure.png",
  link: "/HospitalityPage"
}, {
  id: 3,
  title: "Le Méridien",
  tech: "SPEC: DATA PROTECTION, EDGE ENCRYPTION",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/it_masters_le_meridien_it.png",
  link: "/HospitalityPage"
}, {
  id: 4,
  title: "Enterprise Data Center",
  tech: "SPEC: MULTI-TIER BACKUP, AUDITING",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/it_masters_enterprise_datacenter.png",
  link: "/ServicesPage"
}, {
  id: 5,
  title: "Hospitality Hub UAE",
  tech: "SPEC: MANAGED IT SUPPORT, AMC",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/it_masters_hospitality_hub.png",
  link: "/HospitalityPage"
}, {
  id: 6,
  title: "Cybersecurity Shield",
  tech: "SPEC: THREAT HUNTING, GOLD-STANDARD",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/it_masters_cybersecurity_shield.png",
  link: "/ServicesPage"
}];
export default function Portfolio() {
  return <section data-section-id="226492" id="next-gen-deployments" className="bg-background text-foreground py-24">
      <div className="mx-auto max-w-[1440px] px-[5vw]">
        <div className="mb-12 flex flex-col gap-4">
          <h2 className="font-default text-3xl font-bold tracking-tighter text-foreground md:text-4xl uppercase">
            Next-Gen Deployments
          </h2>
          <p className="max-w-2xl text-muted-foreground font-default">
            Architecting resilient, cost-effective infrastructure for the world's most prestigious hospitality brands and leading enterprises.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {projects.map((project, i) => <Card key={project.id} data-index={i} className="group overflow-hidden rounded-md border border-border bg-card/40 backdrop-blur-md transition-all duration-[600ms] ease-[cubic-bezier(0.16,1,0.3,1)] hover:-translate-y-2 hover:shadow-2xl hover:border-primary/50">
              <div className="relative overflow-hidden">
                <AspectRatio ratio={16 / 9}>
                  <img src={project.image} alt={project.title} className="h-full w-full object-cover transition-transform duration-[600ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-110" />
                </AspectRatio>
                <div className="pointer-events-none absolute inset-0 bg-background/20 mix-blend-multiply transition-colors duration-[600ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:bg-primary/10" />
                {i > 0 && i < 3 && <div className="absolute top-4 right-4 flex items-center gap-2 bg-background/80 backdrop-blur-sm px-3 py-1 rounded-md border border-secondary/50">
                    <span className="h-2 w-2 rounded-lg bg-green-500 animate-pulse" />
                    <span className="font-mono text-[10px] text-secondary font-bold uppercase tracking-widest">Live Deployment</span>
                  </div>}
              </div>
              
              <CardContent className="flex flex-col gap-4 p-6 pt-6">
                <span className="font-mono text-[12px] tracking-widest text-primary font-medium uppercase">
                  {project.tech}
                </span>
                <h3 className="font-default text-xl font-bold text-foreground tracking-tight">
                  {project.title}
                </h3>
                <Button asChild variant="outline" className="mt-2 w-fit border-border bg-transparent text-foreground rounded-md transition-all hover:bg-primary hover:text-primary-foreground hover:border-primary">
                  <Link to={project.link}>View Project Spec</Link>
                </Button>
              </CardContent>
            </Card>)}
        </div>
        
        <div className="mt-16 h-1 w-full bg-muted rounded-md overflow-hidden">
          <div className="h-full w-1/3 bg-primary transition-all duration-1000 ease-in-out" />
        </div>
      </div>
    </section>;
}